// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_dataTable__Emlxu {
  width: 90%;
  margin-bottom: 2.4rem;
  border-spacing: 0px;
  font-size: 1.4rem;
}

.Table_headerRow__A3GUC {
  text-align: left;
  height: 3.2rem;
}

.Table_headerField__Oaoef {
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #111111;
  padding-top: 1.2rem;
  padding-bottom: 0.8rem;
  padding-left: 0.8rem;
}

.Table_dataRows__oJg-k {
  height: 4.8rem;
}
.Table_dataRows__oJg-k:first-child td {
  border-top: 0px;
}
.Table_dataRows__oJg-k:last-child {
  margin-bottom: 1.6rem;
}

.Table_dataField__TEfwH {
  text-align: left;
  overflow-wrap: break-word;
  border-top: 1px solid #ededed;
  max-width: 20rem;
  vertical-align: top;
  padding-top: 1.6rem;
  padding-left: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Table/index.module.scss","webpack://./node_modules/plaid-threads/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;AADF;;AAIA;EACE,6BAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBCbK;EDcL,oBCdK;ADaP;;AAIA;EACE,cAAA;AADF;AAGI;EACE,eAAA;AADN;AAIE;EACE,qBAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBCpCK;ADiCP","sourcesContent":["@import \"~plaid-threads/scss/variables\";\n\n.dataTable {\n  width: 90%;\n  margin-bottom: 3 * $unit;\n  border-spacing: 0px;\n  font-size: 1.4rem;\n}\n\n.headerRow {\n  text-align: left;\n  height: 4 * $unit;\n}\n\n.headerField {\n  border-top: 1px solid $black200;\n  border-bottom: 1px solid $black1000;\n  padding-top: 1.2rem;\n  padding-bottom: $unit;\n  padding-left: $unit;\n}\n\n.dataRows {\n  height: 6 * $unit;\n  &:first-child {\n    td {\n      border-top: 0px;\n    }\n  }\n  &:last-child {\n    margin-bottom: 2 * $unit;\n  }\n}\n\n.dataField {\n  text-align: left;\n  overflow-wrap: break-word;\n  border-top: 1px solid $black200;\n  max-width: 25 * $unit;\n  vertical-align: top;\n  padding-top: 2 * $unit;\n  padding-left: $unit;\n}\n","// All variables definitions belong here.\n// No variable definitions belong in component scss files\n@import 'colors';\n\n// base unit for all sizing, equivalent to 8px\n$unit: 0.8rem;\n\n$font-stack-monospace: Inconsolata, Consolas, Courier, monospace;\n$font-stack-sans: Cern, Helvetica, Arial, sans-serif;\n\n$font-size-large-form-controls: 2rem;\n$height-large-form-controls: 7 * $unit;\n\n// Animation\n$animation-primary-transition-timing-function: cubic-bezier(0.23, 1.2, 0.32, 1);\n$animation-secondary-transition-timing-function: ease-in-out;\n$animation-primary-transition-duration: 350ms;\n$animation-secondary-transition-duration: 100ms;\n$animation-primary: $animation-primary-transition-timing-function\n  $animation-primary-transition-duration;\n$animation-secondary: $animation-secondary-transition-timing-function\n  $animation-secondary-transition-duration;\n\n// Transitions\n$transition-duration: 35ms;\n$transition-delay-duration: 225ms;\n\n// Shadows\n$shadow-1: 0 ($unit * 2) ($unit * 3) 0 $color-box-shadow;\n$shadow-2: 0 $unit ($unit * 2) 0 $color-box-shadow;\n$shadow-3: 0 $unit $unit 0 $color-box-shadow;\n$shadow-4: 0 ($unit * 0.25) ($unit * 0.5) 0 $color-box-shadow;\n\n// deprecated, prefer shadow-1 etc\n$shadow-large: $shadow-1;\n$shadow-medium: $shadow-2;\n$shadow-small: $shadow-3;\n$shadow-xsmall: $shadow-4;\n\n// Stack Order\n$z-index-dropdown: 10;\n$z-index-tooltip: 100;\n$z-index-modal: 1000;\n$z-index-dateInput: 10000;\n\n// Borders\n$border-radius: 0.2rem;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataTable": `Table_dataTable__Emlxu`,
	"headerRow": `Table_headerRow__A3GUC`,
	"headerField": `Table_headerField__Oaoef`,
	"dataRows": `Table_dataRows__oJg-k`,
	"dataField": `Table_dataField__TEfwH`
};
export default ___CSS_LOADER_EXPORT___;
